module.exports = __webpack_public_path__ + "img/undefined.759b8ac.png";